import { ITooltip, Tooltip as ReactTooltip } from "react-tooltip"

import "react-tooltip/dist/react-tooltip.css"

export type TooltipProps = Omit<ITooltip, "disableStyleInjection">

/**
 * Design-system wrapper around `react-tooltip` with our defaults (500ms show
 * delay, clickable content). One instance can serve MANY anchors — elements
 * pointing at it via `data-tooltip-id` — and every instance costs a
 * document-wide MutationObserver, so never mount one per table cell or row.
 * See the Storybook docs page for the patterns to use instead.
 */
export const Tooltip = (rest: TooltipProps) => (
  <ReactTooltip clickable delayShow={500} disableStyleInjection {...rest} />
)
